export function parseDate(
  date: Date,
): { yyyy: string; mm: string; dd: string } {
  const yyyy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString().padStart(2, "0");
  const dd = date.getDate().toString().padStart(2, "0");
  return { yyyy, mm, dd };
}
